import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography, { TypographyProps } from 'src/app/atoms/Typography/Typography';
import CheckItemTextListWithActions, {
  CheckItemTextListWithActionsProps,
} from 'src/app/molecules/CheckItemTextList/CheckItemTextListWithActions';
import AbsolutePositionedAsset from 'src/app/molecules/AbsolutePositionedAsset/AbsolutePositionedAsset';
import { IStaticContentfulImages } from 'src/types/contentful';
import { WidthPropKeys } from 'src/app/styles/spacing';

export interface FreeTrialBlockWithAbsolutePositionedCollageProps {
  headlineProps: TypographyProps;
  checkItemTextListWithActionsProps: CheckItemTextListWithActionsProps;
  contentMaxWidth?: WidthPropKeys;
}

const FreeTrialBlockWithAbsolutePositionedCollage = ({
  headlineProps,
  checkItemTextListWithActionsProps,
  contentMaxWidth = 'width-md',
}: FreeTrialBlockWithAbsolutePositionedCollageProps): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      floatingImage: contentfulAsset(contentful_id: { eq: "LASWiuuk3UMzpoHwxhzP4" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1400)
      }
    }
  `);

  return (
    <Grid
      totalColumns={2}
      totalColumnsLg={1}
      maxWidthLg='width-fit-content'
      position='relative'
      margin={['spacing-none', 'spacing-auto']}
    >
      <Stack
        maxWidth={contentMaxWidth}
        direction='column'
        gap='spacing-4xl'
        padding={['spacing-7xl', 'spacing-none']}
        paddingTopLg='spacing-none'
        zIndex={2}
        position='relative'
        marginLg={['spacing-none', 'spacing-auto']}
      >
        <Typography {...headlineProps} />
        <CheckItemTextListWithActions {...checkItemTextListWithActionsProps} />
      </Stack>
      <AbsolutePositionedAsset
        position={{
          right: '-16%',
          bottom: '-54%',
        }}
        hideOn='lg'
        zIndex={1}
        maxWidth={815}
        imageProps={{
          image: images.floatingImage.gatsbyImageData,
          alt: 'Free trial illustration',
        }}
      />
      <AbsolutePositionedAsset
        position={{
          left: '-10%',
          top: '0%',
        }}
        showOn='lg'
        zIndex={1}
        fillSpaceProps={{
          height: 340,
        }}
        width='120%'
        maxWidth={800}
        imageProps={{
          image: images.floatingImage.gatsbyImageData,
          alt: 'Free trial illustration',
        }}
      />
    </Grid>
  );
};

export default FreeTrialBlockWithAbsolutePositionedCollage;
